import { render, staticRenderFns } from "./RtbStatsByPublisher.vue?vue&type=template&id=6687fef4&scoped=true"
import script from "./RtbStatsByPublisher.vue?vue&type=script&lang=js"
export * from "./RtbStatsByPublisher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6687fef4",
  null
  
)

export default component.exports